import { AxiosRequestConfig } from 'axios';
import { QueryClient, useInfiniteQuery } from '@tanstack/react-query';
import { GetFavoriteQuery } from '@diritto/common/api/RelayContentApi';
import { CONTENT_LIST_PAGE_ITEM_COUNT } from '@diritto/common/content/constants';
import { FavoriteContentsRelayResponseDto } from '@diritto/common/relay/dtos/favorite-content-relay.dtos';
import { RelayContentApi } from 'api/ApiHelper';
import { contentsQueryKey } from 'queries/contents/queryKey';

const getNextPageParam = (
  lastGroup: FavoriteContentsRelayResponseDto,
  allGroups: FavoriteContentsRelayResponseDto[],
) => {
  if (lastGroup.favoriteContents.length < CONTENT_LIST_PAGE_ITEM_COUNT) {
    return undefined;
  }
  return allGroups.reduce((acc, current) => acc + current.favoriteContents.length, 0);
};

export const useGetRelayFavoriteContentsInfiniteQuery = (query: GetFavoriteQuery) =>
  useInfiniteQuery({
    queryKey: contentsQueryKey.favoritesList(query),
    queryFn: ({ pageParam = 0 }) =>
      RelayContentApi.getFavoriteContents({
        offset: pageParam,
        limit: CONTENT_LIST_PAGE_ITEM_COUNT,
        ...query,
      }),
    initialPageParam: 0,
    getNextPageParam,
  });

export const prefetchRelayFavoriteContentsQuery = (
  queryClient: QueryClient,
  options: AxiosRequestConfig,
  query: GetFavoriteQuery,
) =>
  queryClient.fetchInfiniteQuery({
    queryKey: contentsQueryKey.favoritesList(query),
    queryFn: ({ pageParam = 0 }) =>
      RelayContentApi.getFavoriteContents(
        {
          offset: pageParam,
          limit: CONTENT_LIST_PAGE_ITEM_COUNT,
          ...query,
        },
        options,
      ),
    initialPageParam: 0,
    getNextPageParam,
  });
